export default {
  FETCH_INTRODUCED_CAFES_FAILED: "FETCH_INTRODUCED_CAFES_FAILED",
  FETCH_INTRODUCED_CAFES_REJECT: "FETCH_INTRODUCED_CAFES_REJECT",
  FETCH_INTRODUCED_CAFES_LOADING: "FETCH_INTRODUCED_CAFES_LOADING",
  FETCH_INTRODUCED_CAFES_SUCCESS: "FETCH_INTRODUCED_CAFES_SUCCESS",

  FETCH_INTRODUCED_CAFE_DETAILS_SUCCESS: 'FETCH_INTRODUCED_CAFE_DETAILS_SUCCESS',
  FETCH_INTRODUCED_CAFE_DETAILS_LOADING: 'FETCH_INTRODUCED_CAFE_DETAILS_LOADING',
  FETCH_INTRODUCED_CAFE_DETAILS_FAILED: 'FETCH_INTRODUCED_CAFE_DETAILS_FAILED',
  FETCH_INTRODUCED_CAFE_DETAILS_REJECT: 'FETCH_INTRODUCED_CAFE_DETAILS_REJECT',

  CHANGE_INTRODUCED_CAFE_STATUS_FAILED: 'CHANGE_INTRODUCED_CAFE_STATUS_FAILED',
  CHANGE_INTRODUCED_CAFE_STATUS_REJECT: 'CHANGE_INTRODUCED_CAFE_STATUS_REJECT',
  CHANGE_INTRODUCED_CAFE_STATUS_LOADING: 'CHANGE_INTRODUCED_CAFE_STATUS_LOADING',
  CHANGE_INTRODUCED_CAFE_STATUS_SUCCESS: 'CHANGE_INTRODUCED_CAFE_STATUS_SUCCESS',
}